import React from 'react';

class SearchBar extends React.Component {
    constructor(props) {
        super(props);
        this.clearInput = this.clearInput.bind(this)
    }

    clearInput() {
        document.getElementById('searchInput').value = '';
        this.props.getSearchValue();
    }

    render() {
        return (
            <div className="search-container">
                <input id="searchInput" type="text" onKeyUp={this.props.getSearchValue} placeholder="Wyszukaj krążki" />
                <button style={{ 'display': this.props.searchValue !== '' ? '' : 'none' }} id="searchClear"
                    onClick={this.clearInput}>
                    <i className="fa fa-times-circle" />
                </button>
            </div>

        )
    }
}

export default SearchBar



// WEBPACK FOOTER //
// ./src/SearchBar.js